import Service from "../../Services";

const Menu = {
  namespaced: true,
  state: {
    form: {
      menu_id: "",
      branch_id: "",
      service_id: "",
      title_th: "",
      title_en: "",
      description_th: "",
      description_en: "",
      slug_url: "",
      is_publish: true,
      sub_menu: []
    }
  },
  mutations: {
    GET_FORM: (state, res) => {
      state.form = res;
    },
    CLEAR_FORM_DATA: state => {
      state.form = {
        menu_id: "",
        branch_id: "",
        service_id: "",
        title_th: "",
        title_en: "",
        description_th: "",
        description_en: "",
        slug_url: "",
        is_publish: true,
        sub_menu: []
      };
    }
  },
  actions: {
    // eslint-disable-next-line no-unused-vars
    getMenu({ commit }, {page,search,sort_branch,sort_date}) {
      return Service.MenuAPI.getMenu(page,search,sort_branch,sort_date);
    },
    // eslint-disable-next-line no-unused-vars
    showMenu({ commit }, id) {
      return Service.MenuAPI.showMenu(id);
    },
    // eslint-disable-next-line no-unused-vars
    saveMenu({ commit }, { id, data }) {
      if (id) {
        return Service.MenuAPI.updateMenu(id, data);
      } else {
        return Service.MenuAPI.createMenu(data);
      }
    },
    // eslint-disable-next-line no-unused-vars
    deleteMenu({ commit }, id) {
      return Service.MenuAPI.deleteMenu(id);
    },
    // eslint-disable-next-line no-unused-vars
    getAllMenu({ commit }) {
      return Service.MenuAPI.getAllMenu();
    },
    setFormMenu({ commit }, res) {
      commit("GET_FORM", res);
    },
    clearFormData({ commit }) {
      commit("CLEAR_FORM_DATA");
    }
  }
};
export default Menu;
